<template>
  <div class="my-5">
    <div class="listing-header">
     <router-link to="/dashboard/add_categories" class="btn btn-primary">Add Category</router-link>
    </div>
    <table class="table table-striped table-bordered">
      <tr>
        <th width="40%">Name</th>
        <th width="40%">Slug</th>
        <th width="20%">Action</th>
      </tr>
      <tr v-for="(tag, index) in categories" :key="index">
        <td>{{tag.name}}</td>
        <td>{{tag.slug}}</td>
        <td>
          <div class="btn btn-dark" @click="EditHandler(tag.id)" data-toggle="modal" data-target="#tagEdit">Edit</div>
          <div class="btn btn-dark ml-1" @click="deleteHandler(tag.id)" data-toggle="modal" data-target="#tagDelete">Delete</div>
        </td>
      </tr>
    </table>
    <!-- Delete Modal -->
    <div class="modal fade" id="tagDelete" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-body text-center">
            <button type="button" id="delete-modal-close" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
            <h5 class="mb-3">Delete Confirmation</h5>
            <p>Are you sure you want to delete this post ? ( there is no turning back )</p>
            <button class="btn btn-primary mx-3" @click="onConfirm" data-dismiss="modal">Yes, delete</button>
            <button class="btn btn-primary mx-3" @click="onCancel" data-dismiss="modal">No, do not delete it</button>
          </div>
        </div>
      </div>
    </div>
    <!-- Edit Modal -->
    <div class="modal fade" id="tagEdit" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-body text-center">
            <button type="button" id="update-modal-category-close" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
            <h5 class="mb-3">Edit Category</h5>
              <form @submit.prevent="submitHandler">
                  <div class="form-group" :class="{invalid: $v.formdata.name.$error}">
                      <label>Name</label>
                      <input type="text" v-model.trim="$v.formdata.name.$model" class="form-control" placeholder="Name">
                      <div v-if="$v.formdata.name.$error">
                          <p class="error_label_red" v-if="!$v.formdata.name.required">This input is required.</p>
                      </div> 
                  </div>
                  <div class="form-group">
                      <label>Slug</label>
                      <slug-input v-model.trim="$v.formdata.name.$model" @change="onSlugChange($event)" class="form-control" placeholder="Slug"></slug-input>
                      <div v-if="$v.formdata.slug.$error">
                      <p class="error_label_red" v-if="!$v.formdata.slug.required">This input is required.</p>
                      </div>
                  </div>
                  <div class="form-group">
                      <label>Description</label>
                      <textarea v-model.trim="$v.formdata.description.$model" class="form-control" placeholder="Description"></textarea>
                  </div>
                  <button class="btn btn-primary" data-dismiss="modal">Cancel</button>
                  <button type="submit" class="btn btn-primary">Update</button>
              </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import { required,  maxLength, minLength } from 'vuelidate/lib/validators';
export default {
  data() {
    return {
      toDelete: null,
      editCategoryID: 0,
      formdata:{
          name:'',
          slug:'',
          description:''
      }
    };
  },
  validations:{
    formdata:{
        name:{
            required
        },
        slug:{
            required
        },
        description:{}
    }
  },
  computed: {
    categories() {
      let categories = this.$store.getters["admin/getCategories"];

      return categories;
    }
  },
  methods: {
    submitHandler(){
      this.$v.formdata.$touch();
      if(!this.$v.$invalid){
          if(this.formdata.content === ''){
              this.error = true;
          } else {
              this.dialog = true;
              this.updateCategory();
              document.getElementById('update-modal-category-close').click();

          }
      } else {
          this.error = true;
      }
    },
    updateCategory(){
      if(this.editCategoryID){
        this.$store.dispatch('admin/updateCategory', {data : this.formdata, id: this.editCategoryID })
      }
    },
    onSlugChange(event) {
      this.formdata.slug = event;
    },
    deleteHandler(id) {
      this.toDelete = id;
    },
    EditHandler(id) {
      this.editCategoryID = id;
      this.clearCategory();
      this.$store.dispatch('admin/getSingleCategory', id);
      setTimeout(() => {
        this.fillCategoryForm();
      }, 1000);
    },
    fillCategoryForm() {
      let category = this.$store.getters["admin/getSingleCategory"];
      this.formdata = category;
    },
    onConfirm() {
      this.$store.dispatch("admin/deleteCategory", this.toDelete);
    },
    onCancel() {
      this.toDelete = "";
    },
    clearCategory(){
        this.$v.$reset();
        this.formdata ={
            name:'',
            slug:'',
            description:''
        }
    },
  },
  created() {
    this.$store.dispatch("admin/getCategory");
  }
};
</script> 